import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { getSlug } from "@/lib/utils";
import { useI18n } from "@/locales/client";
import { useTRPC } from "@/trpc/client";

export const useCreateNotes = () => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  const router = useRouter();
  const t = useI18n();
  return useMutation(
    trpc.notes.createNotes.mutationOptions({
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: trpc.notes.getNotes.queryKey(),
        });
        const slug = getSlug(data.name, data.id);
        router.push(`/notes/${slug}`);
        toast.success(t("noteView.api.noteCreated"));
      },
      onError: (_error) => {
        toast.error(t("noteView.api.noteCreateFailed"));
      },
    }),
  );
};
